/* istanbul ignore next */
const styles = ({ transitions }) => ({
  indicator: {
    color: '#A8CF38',
    height: 4,
    transitionDuration: transitions.duration.standard,
    transition: transitions.easing.easeInOut
  }
});

export default styles;
